import { useNavigation } from "@react-navigation/native";
import { AHIcon, TouchableBox } from "arkh";
import React, { useCallback } from "react";

import { PLUCategoryItemSpacer } from "./PLUCategoryItemSpacer";
import { UserLoggedInNavigatorNavigationProp } from "../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";

export const PLUCategoryAddItem = React.memo(InnerPLUCategoryAddItem);

function InnerPLUCategoryAddItem() {
  const navigation =
    useNavigation<UserLoggedInNavigatorNavigationProp<"TeamPLU">>();
  const onPress = useCallback(() => {
    navigation.navigateDeprecated("PLUCategoryCreate", {});
  }, [navigation]);
  return (
    <PLUCategoryItemSpacer>
      <TouchableBox
        style={{
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
          borderWidth: 1,
        }}
        cornerRadius="medium"
        borderColor="primary"
        onPress={onPress}
      >
        <AHIcon type="add" color="primary" />
      </TouchableBox>
    </PLUCategoryItemSpacer>
  );
}
